import { Stack } from "@mui/material";
import { useEffect, useState } from "react";

import PaginationControlsV2 from "../../../global/PaginationControlsV2";

const Pagination = ({ filters, updateFilter, totalCount }) => {
  const currentOffset = filters.get("offset") || 0;
  const currentLimit = filters.get("limit") || 100;
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(Math.round(currentOffset / currentLimit) + 1);
  }, [currentOffset, currentLimit]);

  const handlePageChange = (_, value) => {
    setPage(value);
    updateFilter("offset", (value - 1) * currentLimit);
  };

  if (!totalCount) {
    return null;
  }

  return (
    <div id="Case-Search-Pagination">
      <div className="flex flex-row justify-center">
        <div className={`flex w-full justify-center px-0 py-2 md:px-0`}>
          <Stack alignItems={"center"}>
            <PaginationControlsV2
              alignment={"center"}
              resultCount={totalCount}
              handleChange={handlePageChange}
              currentPage={page}
              resultLimit={currentLimit}
            />
          </Stack>
        </div>
      </div>
    </div>
  );
};
export default Pagination;
